import { PawPrint } from "lucide-react";
import shareCardBg from "@/assets/share-card-bg.png";

interface Props {
  backgroundDataUrl?: string;
}

/**
 * Story 13C: "Witaj w społeczności" - wariant z emoji-akcentami i zwięzłym stylem
 */
export const InstagramStoryShare13C = ({ backgroundDataUrl }: Props) => {
  const bgImage = backgroundDataUrl || shareCardBg;

  return (
    <div
      style={{
        width: "1080px",
        height: "1920px",
        fontFamily: "'Nunito', sans-serif",
        display: "flex",
        flexDirection: "column",
        position: "relative",
        overflow: "hidden",
        backgroundColor: "#1a3a2a",
      }}
    >
      <img src={bgImage} alt="" draggable={false} data-export-bg="true" loading="eager" decoding="sync"
        style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", objectFit: "cover", zIndex: 0 }} />
      <div style={{ position: "absolute", top: 0, left: 0, right: 0, height: "8px", background: "linear-gradient(90deg, #4E8A6E 0%, #6BAF8D 50%, #4E8A6E 100%)", zIndex: 2 }} />

      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: "160px 72px",
          position: "relative",
          zIndex: 1,
        }}
      >
        {/* Welcome */}
        <p style={{ fontSize: "40px", fontWeight: 600, color: "#4A7A5E", margin: "0 0 8px", textAlign: "center", lineHeight: 1.4 }}>
          Skoro tu jesteś, to znaczy że
        </p>
        <h1 style={{ fontSize: "64px", fontWeight: 800, color: "#2D5A3D", margin: "0 0 8px", textAlign: "center", lineHeight: 1.2 }}>
          masz dobre serduszko 💚
        </h1>
        <p style={{ fontSize: "36px", fontWeight: 600, color: "#5A8A70", margin: "0 0 40px", textAlign: "center" }}>
          i kochasz zwierzaki 🐾
        </p>

        <div style={{ width: "100px", height: "6px", background: "#4E8A6E", borderRadius: "3px", marginBottom: "40px" }} />

        <p style={{ fontSize: "44px", fontWeight: 800, color: "#2D5A3D", margin: "0 0 36px", textAlign: "center" }}>
          A po co to wszystko? 👇
        </p>

        {/* Cards with emoji headers */}
        <div style={{ display: "flex", flexDirection: "column", gap: "20px", width: "100%", maxWidth: "920px" }}>
          <div style={{ background: "rgba(255,255,255,0.95)", borderRadius: "24px", padding: "32px 40px", boxShadow: "0 4px 16px rgba(0,0,0,0.06)" }}>
            <p style={{ fontSize: "48px", margin: "0 0 8px" }}>🗺️</p>
            <p style={{ fontSize: "32px", fontWeight: 800, color: "#2D5A3D", margin: "0 0 8px", lineHeight: 1.3 }}>
              Zobacz co potrzebują schroniska
            </p>
            <p style={{ fontSize: "27px", fontWeight: 600, color: "#5A8A70", margin: 0, lineHeight: 1.4 }}>
              Na mapie znajdziesz schroniska z okolicy — co potrzebują, czy można tam chodzić na spacery z psami, jak pomóc
            </p>
          </div>

          <div style={{ background: "rgba(255,255,255,0.95)", borderRadius: "24px", padding: "32px 40px", boxShadow: "0 4px 16px rgba(0,0,0,0.06)" }}>
            <p style={{ fontSize: "48px", margin: "0 0 8px" }}>🤝</p>
            <p style={{ fontSize: "32px", fontWeight: 800, color: "#2D5A3D", margin: "0 0 8px", lineHeight: 1.3 }}>
              Uzupełniaj i pomagaj aktualizować
            </p>
            <p style={{ fontSize: "27px", fontWeight: 600, color: "#5A8A70", margin: 0, lineHeight: 1.4 }}>
              Baza jest tworzona przez społeczność — dodaj schronisko, którego brakuje, albo prześlij link schronisku, żeby samo aktualizowało potrzeby
            </p>
          </div>

          {/* Highlighted */}
          <div style={{ background: "rgba(255,255,255,0.95)", borderRadius: "24px", padding: "32px 40px", boxShadow: "0 8px 32px rgba(0,0,0,0.1)", border: "3px solid #4E8A6E" }}>
            <p style={{ fontSize: "48px", margin: "0 0 8px" }}>💚</p>
            <p style={{ fontSize: "32px", fontWeight: 800, color: "#2D5A3D", margin: "0 0 8px", lineHeight: 1.3 }}>
              Zostań — będę tu dla schronisk
            </p>
            <p style={{ fontSize: "27px", fontWeight: 700, color: "#2D5A3D", margin: 0, lineHeight: 1.4 }}>
              Obserwuj to konto, bo regularnie udostępniam zweryfikowane pilne potrzeby konkretnych schronisk — będziesz wiedzieć jak pomóc, bez szukania 🐾
            </p>
          </div>
        </div>
      </div>

      <div style={{ padding: "0 80px 100px", display: "flex", justifyContent: "center", position: "relative", zIndex: 1 }}>
        <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
          <div style={{ background: "#4E8A6E", borderRadius: "14px", width: "52px", height: "52px", display: "flex", alignItems: "center", justifyContent: "center" }}>
            <PawPrint style={{ width: "28px", height: "28px", color: "#FFFFFF" }} />
          </div>
          <span style={{ fontSize: "28px", fontWeight: 700, color: "#2D5A3D" }}>gdzieschronisko.pl</span>
        </div>
      </div>
    </div>
  );
};
